const useDevAPI =
  window.location.hostname.includes("dev") ||
  window.location.hostname.includes("localhost") ||
  window.location.hostname.includes("azurestaticapps.net");

export const AD_BASE_URL = useDevAPI
  ? "https://funker530-ads-staging.azurewebsites.net/api/GetBannerAd?code=bKpRLmbWxP3pqXAN6kqSIqjPmspDCNjOXH8h4BYiWiZYAzFu_7w9pA=="
  : "https://green.funker530.com/api/GetBannerAd?code=sMYsoM1YowbUGryzG47fyGhv7JQ8GFm85SottVJJg3/AhtnBec8nzg==";
export const API_URL =
  process.env.API_LOCATION === "local"
    ? "http://localhost:7071/api/"
    : useDevAPI
      ? "https://funker530-fnc-staging.azurewebsites.net/api/"
      : "https://api.funker530.com/api/";
export const API_CODE = useDevAPI
  ? "vuqwRsFKwFlKIJ5lWpM7mq7pjzpOTWbHSmrz3aacsuasAzFu85TPoQ=="
  : "sL3mjD-c0BJdI9b9h4s7WhIPU8ca9p6h3yiLyFczS-I9AzFupvbo9g==";
// export const API_CODE =
//   "sL3mjD-c0BJdI9b9h4s7WhIPU8ca9p6h3yiLyFczS-I9AzFupvbo9g==";
// Scout/Analytics survey-response ingest (powers the first-load survey modal).
export const SURVEY_API_URL = useDevAPI
  ? "http://localhost:3001/api/survey"
  : "https://scout20.vercel.app/api/survey";
// Scout/Analytics active-survey read. Returns the single survey a platform
// admin has activated (question, answers, target_path) or { survey: null }.
export const SURVEY_ACTIVE_API_URL = useDevAPI
  ? "http://localhost:3001/api/survey/active"
  : "https://scout20.vercel.app/api/survey/active";
// Scout/Analytics ad serve endpoint. Vendor-1 ads from the legacy Ad Function
// are re-served from here (see AdContext.GetScoutAd / Ad component).
export const SCOUT_SERVE_URL = useDevAPI
  ? "http://localhost:3001/api/serve"
  : "https://scout20.vercel.app/api/serve";
// Scout/Analytics conversion pixel, used to report a funker530 account signup
// as a checkout (see ReportSignupToScout in Pages/Authentication/Register).
// Deliberately not switched on useDevAPI: public/index.html loads the
// production scout.js in every environment, so this is the pixel that script
// talks to.
export const SCOUT_CONVERSION_PIXEL_ID = "18f5e894-4a9e-4475-9f55-86853631dccf";
export const IMAGES_BASE_URL = "https://images.funker530.com/images/media/";
export const DEFAULT_AVATAR_IMAGE = "anon.png";
export const MAIN_SITE_URL = "https://funker530.com";
